var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v(_vm._s(_vm.label))]),_c('link-component',{attrs:{"name":_vm.name,"params":_vm.params}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }